import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";

const Navvbar1 = ({
    brandName,
    docName,
    accDeta,
    className,
    sections,
    onToggle,
}) => {
    return (
        <Navbar expand="lg" className={`${className}`}>
            <Container fluid>
                <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />
                <Navbar.Offcanvas
                    id="offcanvasNavbar-expand-lg"
                    aria-labelledby="offcanvasNavbarLabel-expand-lg"
                    placement="end"
                >
                    <Offcanvas.Header closeButton>
                        <div>
                            <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                                {brandName}
                            </Offcanvas.Title>

                            <h4>{docName}</h4>
                            <h6>{accDeta}</h6>
                        </div>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            {sections?.map((section, index) => (
                                <div key={index} className="nav-bar-block">
                                    <h4 className="exado-title-seven">{section?.title}</h4>
                                    {section.items.map((item, idx) =>
                                        item.type === "dropdown" ? (
                                            <NavDropdown
                                                title={item.title}
                                                id={`nav-dropdown-${index}-${idx}`}
                                                key={idx}
                                                className="exado-title-six"
                                                onToggle={onToggle}
                                            >
                                                {item.options.map((option, optIdx) => (
                                                    <NavDropdown.Item
                                                        key={optIdx}
                                                        eventKey={`dropdown-${index}-${idx}-${optIdx}`}
                                                        className="exado-title-six"
                                                        as={Link}
                                                        to={option.path}
                                                    >
                                                        {option.label}
                                                    </NavDropdown.Item>
                                                ))}
                                            </NavDropdown>
                                        ) : (
                                            <Nav.Link
                                                as={Link}
                                                to={item.path}
                                                key={idx}
                                                eventKey={`link-${index}-${idx}`}
                                                className="exado-title-six"
                                                onClick={item.onClick}
                                            >
                                                {item.label}
                                            </Nav.Link>
                                        )
                                    )}
                                </div>
                            ))}
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
};

export default Navvbar1;
